$(document).ready(function () {
  Site.init();
  Plugins.init();
  Form.Submit();

  Form.InscricaoEvento();
});

//
//
//
// SITE FUNCTIONS
//
Site = {};
Site.init = function () {
  Site.Ie10();
  Site.Menu();
};
Site.Lazy = function () {
  $('.lazy').Lazy(
    {
      scrollDirection: 'vertical',
      effect: 'fadeIn',
      effectTime: 1000,
      threshold: 0,
      delay: 1000
    }
  );
}
Site.Ie10 = function () {
  var doc = document.documentElement;
  doc.setAttribute('data-useragent', navigator.userAgent);
}
Site.Menu = function () {
  action_clickMenuToScroll();
  action_onLoadScroll();

  function action_clickMenuToScroll() {
    $itemMenu = $('header .navbar-light .navbar-nav .nav-link');
    $itemMenu.click(function () {
      $section = $(this).attr('href');
      $scrollSection = '#' + getHashFromURL($section);
      scrollToDiv($scrollSection);

      if (Site.isMobile()) {
        $('header .navbar .container .navbar-toggler').trigger('click');
      }
    });
  }
  function action_onLoadScroll() {
    $section = getHashFromURL();
    if ($section) {
      $scrollSection = '#' + $section;
      scrollToDiv($scrollSection);
    }
  }
  function getHashFromURL($url) {
    if (!$url) {
      $url = $(location).attr('href');
    }
    $formTag = $url.split('#');
    return $formTag[1];
  }
  function scrollToDiv($scrollSection) {
    $altura = 150;
    if (Site.isMobile()) {
      $altura = 80
    }

    $('html, body').animate({
      scrollTop: $($scrollSection).offset().top - $altura
    }, 800);
  }
}
Site.isMobile = function () {
  var isMobile = false; //initiate as false
  // device detection
  if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
    isMobile = true;
  }
  return isMobile;
}

////
//
// FUNCTIONS
//
Functions = {};
Functions.validarCPF = function () {
  $(".input-cpf").blur(function () {
    if ($(this).val() != "") {
      var cpfInput = $(this).val();
      cpfInput = cpfInput.replace(".", "");
      cpfInput = cpfInput.replace(".", "");
      cpfInput = cpfInput.replace("-", "");
      //Verifica CPF
      if (!valida(cpfInput)) {
        alert('CPF inválido.');
        $(this).val("");
      }
    }
  });

  function valida(cpf) {
    var numeros, digitos, soma, i, resultado, digitos_iguais;
    digitos_iguais = 1;
    if (cpf.length < 11)
      return false;
    for (i = 0; i < cpf.length - 1; i++)
      if (cpf.charAt(i) != cpf.charAt(i + 1)) {
        digitos_iguais = 0;
        break;
      }
    if (!digitos_iguais) {
      numeros = cpf.substring(0, 9);
      digitos = cpf.substring(9);
      soma = 0;
      for (i = 10; i > 1; i--)
        soma += numeros.charAt(10 - i) * i;
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(0))
        return false;
      numeros = cpf.substring(0, 10);
      soma = 0;
      for (i = 11; i > 1; i--)
        soma += numeros.charAt(11 - i) * i;
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(1))
        return false;
      return true;
    } else
      return false;
  }
}


////
//
// PLUGINS FUNCTIONS
//
Plugins = {};
Plugins.init = function () {
  Plugins.Form();
}
Plugins.Form = function () {
  $('.form-validate').parsley();

  $(".input-rg").mask("99.999.999-~", { reverse: true });
  $(".input-data").mask("99/99/9999");
  $(".input-cpf").mask("999.999.999-99");
  $(".input-cnpj").mask("99.999.999/9999-99");
  $(".input-cep").mask("99999-999");
  $(".input-phone").mask("(99) 9999-99999");
  $(".input-telefone").mask("(99) 9999-9999?9")
    .focusout(function (event) {
      var target, phone, element;
      target = (event.currentTarget) ? event.currentTarget : event.srcElement;
      phone = target.value.replace(/\D/g, '');
      element = $(target);
      element.unmask();
      if (phone.length > 10) {
        element.mask("(99) 99999-999?9");
      } else {
        element.mask("(99) 9999-9999?9");
      }
    });
}

////
//
// FORM FUNCTIONS
//
Form = {};
Form.Submit = function () {
  $('.form-validate').submit(function () {
    $(this).find('input').attr('readonly', true);
    $(this).find('button[type="submit"]').attr('disabled', true);
    return true;
  });
}
Form.Preinscricao_response = function (data) {
  var form = $('#view_inscricao .sec2 .form');
  var msg = $('#view_inscricao .sec2 .msg-response');

  console.log(data[0]);
  console.log(data[0]['code']);

  if (data[0]['code'] == 201) {
    form.fadeOut(400);
    setTimeout(function () {
      msg.fadeIn(400);
    }, 380);
  }else{
    alert(data[0]['title']);
  }


}
Form.InscricaoEvento = function () {

  select_formaPagamento();

  function select_formaPagamento() {
    $('.form-inscricaoEvento input[name="forma_pagamento"]').change(function(){
      var formaPag = $(this).val();
      var boxBoleto = $('.form-inscricaoEvento .box-boleto');
      var boxTransf = $('.form-inscricaoEvento .box-transferencia');

      if( formaPag == 'boleto' ){

        requiredCPF(true);

        boxTransf.fadeOut(100);
        setTimeout(function(){
          boxBoleto.fadeIn();
        }, 100);

      }else if( formaPag == 'transferencia' ){

        requiredCPF(false);

        boxBoleto.fadeOut(100);
        setTimeout(function(){
          boxTransf.fadeIn();
        }, 100);

      }
    });
  }

  function requiredCPF($status) {
    var inputCPF = $('.form-inscricaoEvento input[name="cpf"]');

    if($status){
      inputCPF.attr('required', '');
    }else{
      inputCPF.removeAttr('required');
    }
    
  }

}
